import React from 'react';
import { Handle, Position } from 'reactflow';

const EndNode = ({ data }) => {
  return (
    <div className="end-node">
      <Handle
        type="target"
        position={Position.Top}
        style={{}}
      />
      End
    </div>
  );
};

export default EndNode; 